import type { IStatusIndicator } from "../../types/status_indicator";
import { StateIcon } from "../StateIcon";
import styles from "./status-indicator.module.scss";

export const StatusIndicator = ({
  status = 'default',
  icon,
  text,
  hintText
}: IStatusIndicator) => {
  return (
    <div className={styles["status-indicator"]}>
      {
        icon &&
        <StateIcon
          status={status}
          icon={icon}
        />
      }

      {text && <div className={styles["status-indicator__text"]}>{text}</div>}

      {hintText && <div className={styles["status-indicator__hint-text"]}>{hintText}</div>}
    </div>
  )
}